// extracted by mini-css-extract-plugin
export default {"docsDiv":"docs_docsDiv__jpBPI","jsonKey":"docs_jsonKey__EgxCd","jsonValue":"docs_jsonValue__VeDAT","jsonStruct":"docs_jsonStruct__Q+jSx"};